import React from 'react';
import config from 'src/config';

const linkNames = {
  spice: {
    name: 'SPICE',
    order: 1
  },
  chatsales: {
    name: 'First sale link',
    order: 2,
    join: 'andy'
  },
  sexplaycam: {
    name: 'Biller 3',
    // bold: true,
    order: 3
  },
  easysex: {
    name: 'Easy NEW Biller',
    // hot: true,
    order: 4
  },
  andy60: {
    name: 'ALinks',
    // hot: true,
    order: 5
  },
  // hg1: {
  //   name: 'Auth 1',
  //   order: 6,
  //   join: 'andy1'
  // },
  andy1: {
    name: 'CPS',
    order: 6,
  },
  cevip: {
    name: 'CVIP',
    order: 7
  },
  cupid: {
    name: 'Cupid links',
    order: 8
  },
  // loc: {
  //   name: 'Loc links',
  //   order: 9
  // },
  dgold: {
    name: 'DGold',
    order: 10
  },
  punk: {
    name: 'PunkBank',
    order: 11
  },
  gaylinks: {
    name: 'GLinks',
    order: 12
  },
  hookupbay: {
    name: 'HBay',
    order: 13
  },
  chrissales: {
    name: 'KLink',
    order: 14
  },
  imlive: {
    name: 'Livecam',
    order: 15
  },
  sms: {
    name: 'SMSLinks',
    order: 16
  },
  sandra_sales: {
    name: 'SandraCams',
    order: 17
  },
  hgh2: {
    name: 'Higher',
    order: 18
  },
  wellhello: {
    name: 'Wellhello',
    order: 19
  }
  // andy: {
  //   name: 'A',
  //   order: 17,
  //   joined: 'chatsales',
  // },
  // andy1: {
  //   name: 'A1',
  //   order: 18,
  //   joined: 'hg1',
  // },
};

class Component extends React.Component {
  state = {
    offers: []
  };

  componentDidMount() {
    let { user, userOffers, currentTab } = this.props;
    let offers = userOffers
      .filter((offer) => linkNames[offer])
      .sort((a, b) => {
        return linkNames[a].order > linkNames[b].order ? 1 : -1;
      });
    this.setState({ offers });

    if (!this.props.currentTab) {
      console.log('offers', offers);
      this.props.openTab(offers[0]);
    }
  }

  render() {
    let { user, currentTab } = this.props;
    let offers = this.state.offers || [];

    let mid = parseInt(user.master_wid) || parseInt(user.owner_wid) || parseInt(user.aid);
    let customCevipName = mid == 2374 || mid == 7300;

    return (
      <div class='nav-active-primary b-b b-primary'>
        <ul class='nav nav-tabs'>
          {offers.map((offer) => (
            <li key={offer} value={offer} class='nav-item'>
              <a
                class={
                  'nav-link ' +
                  (currentTab == offer ? 'active ' : '') +
                  (linkNames[offer] && linkNames[offer].hot ? 'link-hot ' : '') +
                  (linkNames[offer] && linkNames[offer].bold ? 'link-bold ' : '')
                }
                onClick={(e) => this.props.openTab(offer, e)}
              >
                {linkNames[offer] && (
                  <span>
                    {linkNames[offer].hot && <span class='link-hot-hot'>Hot: </span>}
                    {(linkNames[offer].name != 'CVIP' || !customCevipName) && (
                      <span
                        class={linkNames[offer] && linkNames[offer].bold ? 'link-name-bold' : ''}
                      >
                        {linkNames[offer].name}
                      </span>
                    )}
                    {linkNames[offer].name == 'CVIP' && customCevipName && (
                      <span style={{ fontWeight: 'bold', color: 'black' }}>TGM</span>
                    )}
                  </span>
                )}
                {!linkNames[offer] && <span>{offer}</span>}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

import api from 'src/actions/api';
import setState from 'src/actions/state';
import { connect } from 'react-redux';

export default connect(
  function (state) {
    return {
      apiState: state.api['links_available'] || state.api.initial,
      state: state.state['links_available'] || state.state.initial,
      user: state.session.user
    };
  },
  { api, setState: setState('links_available') }
)(Component);
